const productionApiOrigin = 'https://api.virtus-one.com';
const localApiOrigin = 'http://127.0.0.1:8000';
const configuredApiOrigin = (
  process.env.NODE_ENV === 'development'
    ? localApiOrigin
    : process.env.REACT_APP_BACKEND_URL || productionApiOrigin
).replace(/\/$/, '');

export const apiBaseUrl = configuredApiOrigin;

const rewriteApiRequest = (input) => {
  if (configuredApiOrigin === productionApiOrigin) {
    return input;
  }

  const requestUrl = typeof input === 'string' ? input : input?.url;
  if (!requestUrl || !requestUrl.startsWith(productionApiOrigin)) {
    return input;
  }

  const rewrittenUrl = `${configuredApiOrigin}${requestUrl.slice(productionApiOrigin.length)}`;
  return typeof input === 'string' ? rewrittenUrl : new Request(rewrittenUrl, input);
};

export default function configureApiFetch() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || configuredApiOrigin === productionApiOrigin) {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => originalFetch(rewriteApiRequest(input), init);
}